import {  format as formatDate } from 'date-fns';
import DateHelper from 'app/helpers/dateHelper';
import { isDefined } from 'app/helpers/objectHelper';

export interface DateDisplayProps {
    value?: string
}

export const DateDisplay = (value:string|undefined) => (
    !isDefined(value) ? '-' : formatDate(DateHelper.ToDate(value),'dd MMM yyyy')
)
